/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{font-size:.8rem}[_nghost-%COMP%]   .blue-background[_ngcontent-%COMP%]{background-color:#0080ff!important}"];
export { styles as styles };
//# sourceMappingURL=tile-progress-label.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/generic-tile/tile-progress-label/tile-progress-label.component.scss.shim.ngstyle.js
// module id = 1560
// module chunks = 27 28 29